<template>
  <div>
    <v-col cols="12" md="6" class="pt-0 pl-0">
      <gg-text-field outlined
                     v-model="search"
                     append-icon="mdi-magnify"
                     single-line
                     hide-details></gg-text-field>
    </v-col>
    <v-data-table :headers="headers"
                  :search="search"
                  :loading="!cronJobsLoaded"
                  :items="items"
    >

      <template v-slot:item.actions="{ item }">
        <v-menu bottom offset-y min-width="180">
          <template v-slot:activator="{ on, attrs }">
            <gg-btn v-on="on" v-bind="attrs">
              Manage
              <v-icon right>mdi-chevron-down</v-icon>
            </gg-btn>
          </template>
          <v-list>
            <v-list-item @click="openEditModal(item)">
              <v-list-item-title>
                Edit
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="openDeleteModal({ count: item.count })">
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <delete-cron-job-dialog v-if="selectedCronJob"
                            :opened="deleteModal"
                            :job="selectedCronJob"
                            @close="closeDeleteModal"
                            @job-deleted="reload"
    />
    <edit-cron-job-dialog v-if="selectedCronJob"
                          :opened="editModal"
                          :job="selectedCronJob"
                          @close="closeEditModal"
                          @job-updated="reload"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteCronJobDialog from './DeleteCronJobDialog'
import EditCronJobDialog from './EditCronJobDialog'

export default {
  name: 'CronJobsTable',
  components: {
    DeleteCronJobDialog,
    EditCronJobDialog,
  },
  props: {
    tableShouldBeReloaded: {
      type: Boolean,
      required: false,
    },
  },
  data () {
    return {
      headers: [
        {
          text: 'Minute',
          value: 'minute',
        },
        {
          text: 'Hour',
          value: 'hour',
        },
        {
          text: 'Day',
          value: 'day',
        },
        {
          text: 'Month',
          value: 'month',
        },
        {
          text: 'Weekday',
          value: 'weekday',
        },
        {
          text: 'Command',
          value: 'command',
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
        }
      ],
      cronJobsLoaded: false,
      search: '',
      selectedCronJob: null,
      deleteModal: false,
      editModal: false,
    }
  },
  computed: {
    ...mapGetters(['cronJobs', 'pagination']),
    items () {
      return this.cronJobs.filter(cj => !cj.command.includes('softaculous'))
    }
  },
  methods: {
    ...mapActions(['getCronJobsList', 'reportError']),
    reload () {
      this.cronJobsLoaded = false
      this.getCronJobsList({ _username: this.$route.query.user }).then(() => {
        this.cronJobsLoaded = true
        this.$emit('table-reloaded')
      }).catch(error => {
        this.reportError(error)
      })
    },
    openDeleteModal (job) {
      this.selectedCronJob = job
      this.deleteModal = true
    },
    closeDeleteModal () {
      this.selectedCronJob = null
      this.deleteModal = false
    },
    openEditModal (job) {
      this.selectedCronJob = { ...job }
      this.editModal = true
    },
    closeEditModal () {
      this.selectedCronJob = null
      this.editModal = false
    },
  },
  watch: {
    tableShouldBeReloaded (val) {
      if (val) {
        this.reload()
      }
    }
  },
  created () {
    this.reload()
  },
}
</script>
